import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MailingAddressComponent } from '../../common/components/mailing-address/mailing-address.component';
import { CreditComponent } from '../../common/components/credit/credit.component';
import { QuoteService } from '../../services/quote.service';
import { FileService } from '../../services/file.service';
import { Credit } from '../../core/models/credit.model';
import { GridApi } from 'ag-grid-community';
import { ContactDetailsComponent } from '../../common/components/contact-details/contact-details.component';

import { QUOTE_APPLICATION, QUOTE_CREDIT } from '../../core/models/quote-register.model';
import { Applicant } from '../../core/models/applicant-model';
import { ADDRESS } from '../../core/models/address.model';
import { Contact } from '../../core/models/contact.model';
import { HelperService } from '../../services//helper.service';
import { LookupService } from '../../services//lookup.service';
import { UtilityService } from '../../services/utility.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { QuoteFileTypes } from '../../core/constants/status.constants';
import { ValidatorExt } from 'src/app/core/helpers/validators';
import { Helper } from 'src/app/core/helpers/helper';
import { TooltipDisplayRegisterContext } from 'src/app/services/tooltip-display.types';
import { AgGridHeaderTooltipComponent } from 'src/app/common/components/ag-grid-header-tooltip/ag-grid-header-tooltip.component';

@Component({
  selector: 'app-rfq',
  templateUrl: './rfq.component.html',
  styleUrls: ['./rfq.component.css']
})

export class RfqComponent {
  @ViewChild('mailingAddress', { static: true }) mailingAddress: MailingAddressComponent;
  @ViewChild('creditModal', { static: true }) creditsModal: CreditComponent
  //@ViewChild('deleteConfirmModal', { static: true }) deleteConfirmModal: AlertModelComponent;
  @ViewChild('primaryContact', { static: true }) primaryContact: ContactDetailsComponent;
  @ViewChild('secondaryContact', { static: true }) secondaryContact: ContactDetailsComponent;

  readonly mailingAddressTooltipContext: TooltipDisplayRegisterContext = {
    register: 'QuoteRegister',
    tab: 'RFQ',
    section: 'Applicant Details',
    fieldName: 'Mailing Address'
  };

   readonly primaryContactTooltipContext: TooltipDisplayRegisterContext = {
    register: 'QuoteRegister',
    tab: 'RFQ',
    section: 'Contact Details',
    fieldName: 'Primary contact'
  };

  readonly secondaryContactTooltipContext: TooltipDisplayRegisterContext = {
    register: 'QuoteRegister',
    tab: 'RFQ',
    section: 'Contact Details',
    fieldName: 'Secondary contact'
  };

  public applicantFg: UntypedFormGroup;
  public addressFg: UntypedFormGroup;
  public developmentFg: UntypedFormGroup;
  public filesFg: UntypedFormGroup;
  public authFg: UntypedFormGroup;

  gridApi: GridApi;
  contacts: any[] = [];
  obligations: any = [];
  fileTypes: any = [];
  lgas: any = [];
  developmentTypes: any = [];
  obligationTypes: any = [];
  documents: any = [];
  fileNSW1: any = null;
  fileNSW2: any = null;
  fileCW: any = null;
  fileCR: any = null;
  fileES: any = null;

  consent1: boolean = false;
  consent2: boolean = false;
  submitted: boolean = false;
  public defaultColDef = {
    flex: 1,
    resizable: true,
    //floatingFilter: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
  };


  creditColumnDefs: any = [
    {
      headerName: 'Delete',
      maxWidth: 125,
      headerComponent: AgGridHeaderTooltipComponent,
      headerComponentParams: {
        tooltipContext: {
          register: 'QuoteRegister',
          tab: 'RFQ',
          section: 'Biodiversity credit obligations',
          fieldName: 'Delete'
        }
      },
      cellRenderer: params => {
        return `<div><button class='btn danger' title='Delete'><i class="fa fa-trash" aria-hidden="true"></i></button></div>`;
      }
    },
    {
      headerName: 'IBRA Subregion', field: 'ibraSubregion', sortable: true, filter: 'agTextColumnFilter', maxWidth: 175, minWidth: 150
    },
    {
      headerName: 'Credit category', field: 'creditCategory', sortable: true, filter: 'agTextColumnFilter', maxWidth: 150, minWidth: 125
    },
    {
      headerName: 'Credit type ID', field: 'creditTypeId', sortable: true, filter: 'agTextColumnFilter', maxWidth: 150, minWidth: 125
    },
    {
      headerName: 'Offset Trading group', field: 'offsetTradingGroup', sortable: true, filter: 'agTextColumnFilter', minWidth: 250
    },
    {
      headerName: 'Hollow-Bearing Tree Status', valueGetter: params => Helper.hbtValueGetter(params), sortable: true, filter: 'agTextColumnFilter', maxWidth: 225
    },
    {
      headerName: 'EPBC Act offset (Yes/No)', valueGetter: params => params.data.commonwealthOffset ? "Yes" : "No", sortable: true, filter: 'agTextColumnFilter', maxWidth: 250
    },
    {
      headerName: 'No. of Credits', field: 'numberOfCredits', sortable: true, filter: 'agTextColumnFilter', maxWidth: 175, minWidth: 150
    }
  ];

  constructor(private formBuilder: UntypedFormBuilder, private router: Router, private quoteService: QuoteService,
    private helperService: HelperService, private activeRoute: ActivatedRoute,
    private lookupService: LookupService, private utilityService: UtilityService,
    private fileService: FileService
  ) {

  }

  ngOnInit() {
    this.generateForms();
    this.loadLookups();
    const id = Number(this.activeRoute.snapshot.paramMap.get('id'));
    if (!isNaN(id) && id > 0) this.editApplication(id);
    this.defaultColDef = {
      flex: 1,
      resizable: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
    };
  }

  get appicationId(): number {
    return this.applicantFg.get('id').value;
  }

  get validApplication(): boolean {
    const contact = this.primaryContact.getContact();
    return this.applicantFg.valid
      && this.developmentFg.valid
      && (contact.firstName.trim() != "" && contact.email.trim() != ""
        && (contact.phone.trim() != "" || contact.mobile.trim() != ""))

  }

  get isValidPrimaryContact(): boolean {
    const contact = this.primaryContact.getContact() as Contact;
    if (contact == null) return false;
    return contact.firstName.trim() != "" && contact.email.trim() != ""
      && (contact.phone.trim() != "" || contact.mobile.trim() != "");
  }

  get showSubmit(): boolean {
    const status = this.applicantFg.value.status;
    return this.applicantFg.value.id > 0 && (status == null || status == '' || status == 'DFT');
  }

  get allowSubmit(): boolean {
    return this.validApplication
      && this.consent1 && this.consent2
      && this.validApplication
      && (this.fileNSW1 != null || this.fileNSW2 != null || this.isDocumentUploaded(1) || this.isDocumentUploaded(2))
      && (this.isDocumentUploaded(4) || this.filesFg.valid)
      && this.authFg.valid && this.obligations != null && this.obligations.length > 0;
  }

  get isDraft(): boolean {
    const status = this.applicantFg.value.status;
    return status == null || status == '' || status == 'DFT';
  }

  get allowDelete(): boolean {
    const status = this.applicantFg.value.status;
    return this.applicantFg.value.id > 0 && (status == null || status == '' || status == 'DFT' || status== 'PROG');
  }

  isDocumentUploaded(index: number): boolean {
    if (this.documents == null || this.documents.length <= 0) return false;
    switch (index) {
      case 1:
        return this.documents.filter(x => x.fileTypeCode == QuoteFileTypes.NSWDevelopmentApplication).length > 0;
      case 2:
        return this.documents.filter(x => x.fileTypeCode == QuoteFileTypes.NSWDevelopmentApproved).length > 0;
      case 3:
        return this.documents.filter(x => x.fileTypeCode == QuoteFileTypes.CommonwealthApproved).length > 0;
      case 4:
        return this.documents.filter(x => x.fileTypeCode == QuoteFileTypes.CreditReport).length > 0;
      case 5:
        return this.documents.filter(x => x.fileTypeCode == QuoteFileTypes.EquivalenceStatement).length > 0;
      default:
        return false;
    }
  }

  getDocumentName(index: number): string {
    if (this.documents == null || this.documents.length <= 0) return "";
    let document: any = null
    switch (index) {
      case 1:
        document = this.documents.find(d => d.fileTypeCode == QuoteFileTypes.NSWDevelopmentApplication);
        break;
      case 2:
        document = this.documents.find(d => d.fileTypeCode == QuoteFileTypes.NSWDevelopmentApproved);
        break;
      case 3:
        document = this.documents.find(d => d.fileTypeCode == QuoteFileTypes.CommonwealthApproved);
        break;
      case 4:
        document = this.documents.find(d => d.fileTypeCode == QuoteFileTypes.CreditReport);
        break;
      case 5:
        document = this.documents.find(d => d.fileTypeCode == QuoteFileTypes.EquivalenceStatement);
        break;
    }

    return document != null ? document.name : "";

  }

  generateForms() {
    this.applicantFg = this.formBuilder.group({
      id: [0],
      applicantId: [0],
      name: ['', Validators.required],
      applicantType: ['', Validators.required],
      abn: ['', ValidatorExt.abnAcn()],
      status: [''],
      referenceNumber: [''],
      category: [''],
      geographicRegion: [''],
      bctContact: [],
      submittedDate: [],
      quoteIssueDueDate: [''],
      adjustedIssueDueDate: [''],
      adjustedDueDateReason: [''],
      issuedDate: [],
      expiryDate: [],
      adjustedExpiryDate: [''],
      adjustedExpiryDateReason: [''],
      cancelReason: [],
      quoteCancelReason: [],
      queryReason: [],
      queryReasonFlag: [0],
      cm9ContainerID: [''],
      cm9reference: ['']

    });

    this.developmentFg = this.formBuilder.group({
      developmentName: ['', Validators.required],
      developmentTypeId: ['', Validators.required],
      lga: ['', Validators.required],
      obligationType: ['', Validators.required],
      obligationReference: [''],
      cwObligationReference: ['']
    });

    //Files group
    const MAX_FILE_LENTH: number = 100;
    this.filesFg = this.formBuilder.group({
      nsw1: ['', [Validators.maxLength(MAX_FILE_LENTH)]],
      nsw2: ['', [Validators.maxLength(MAX_FILE_LENTH)]],
      cw: ['', [Validators.maxLength(MAX_FILE_LENTH)]],
      cr: ['', [Validators.required, Validators.maxLength(MAX_FILE_LENTH)]],
      es: ['', [Validators.maxLength(MAX_FILE_LENTH)]]
    });

    //Auth form group
    this.authFg = this.formBuilder.group({
      name: ['', Validators.required],
      organisation: ['', Validators.required],
      authOption: ['', Validators.required]
    });

    this.mailingAddress.resetForm()
  }

  loadLookups() {
    this.lookupService.getClassifications(['QTEF']).subscribe(result => {
      this.fileTypes = result;
    });

    //load LGAs
    this.lookupService.getLGAs().subscribe(results => { this.lgas = results });

    //load development tyes
    this.lookupService.getDevelopmentTypes().subscribe(results => { this.developmentTypes = results });

    //obligation types
    this.lookupService.getClassifications(['OBLT']).subscribe(result => {
      this.obligationTypes = result;
    });
  }

  saveDraft() {

    const application = this.buildApplicantion();
    const applicationId = Number(application.id);
    if (isNaN(applicationId) || applicationId <= 0) {
      this.quoteService.save(application).subscribe(result => {
        this.helperService.toasterService.success(`Draft application has been saved successfully. Quote reference number is: ${result.referenceNumber}`);
        console.log('Draft application saved with result:', result);

        this.applicantFg.patchValue({
          id: result.id,
          applicantId: result.applicantId,
          referenceNumber: result.referenceNumber,
          status: result.status
        });

        const address = result.applicant?.addresses?.[0];
        if (address) {
         this.mailingAddress.formGroup.patchValue({
              id: address.id,
              type: address.type
            });
        }
       
      }), error => {
        this.helperService.toasterService.error("Unable to submit your application.");
      };
    }
    else {
      console.log('Updating existing application with ID:', applicationId);
      const applicantId = this.applicantFg.value.applicantId;
      application.applicantId = applicantId;
      application.applicant.id = applicantId;
      console.log('Application data being sent for update:', application);
      this.quoteService.update(application).subscribe(result => {
        this.helperService.toasterService.success('Draft application has been updated successfully.');
      }), error => {
        this.helperService.toasterService.error("Unable to submit your application.");
      };
    }
  }

  Update() {
    const application = this.buildApplicantion();
    const applicantId = this.applicantFg.value.applicantId;
    application.applicantId = applicantId;
    application.applicant.id = applicantId;
    this.quoteService.update(application).subscribe(result => {
      this.helperService.toasterService.success('Application has been updated successfully.');
    }), error => {
      this.helperService.toasterService.error("Unable to update your application.");
    };
  }

  submit() {
    const application = this.buildApplicantion();
    const applicantId = this.applicantFg.value.applicantId;
    application.id = this.applicantFg.value.id;

    application.applicantId = applicantId;
    application.applicant.id = applicantId;

    this.quoteService.submit(application).subscribe(result => {
      this.submitted = true;
      this.helperService.toasterService.success("Quote application has been submitted successfully.");
      console.log('Navigating to confirmation with state:', {
        referenceNumber: application.referenceNumber,
        applicationId: application.id
      });
      this.router.navigate(['/quotes/rfq/confirmation'], { 
        state: { 
          referenceNumber: application.referenceNumber,
          applicationId: application.id 
        } 
      });
    });
  }

  buildApplicantion(): QUOTE_APPLICATION {

    let application: QUOTE_APPLICATION = new QUOTE_APPLICATION();
    let applicant: Applicant = {};
    let mailingAddress: ADDRESS;
    let contact: Contact;
    let addressess: ADDRESS[] = [];
    let contacts: Contact[] = [];

    //applicant
    applicant.firstName = this.applicantFg.value.name;
    applicant.applicantType = "DEV";
    applicant.subType = this.applicantFg.value.applicantType;
    applicant.abn = this.applicantFg.value.abn;


    //mailing address
    mailingAddress = this.mailingAddress.formValue;
    mailingAddress.id = mailingAddress.id == null ? 0 : mailingAddress.id;
    addressess.push(mailingAddress);
    applicant.addresses = addressess;
    contact = this.primaryContact.getContact();
    contact.type = "P";
    contacts.push(contact);
    contact = this.secondaryContact.getContact();
    contact.type = "S";
    contacts.push(contact);
    applicant.contacts = contacts;

    //application
    application.id = this.applicantFg.value.id;
    application.applicant = applicant;
    //set default status to Draft for new applications
    application.status = !isNaN(application.id) && application.id > 0 ? this.applicantFg.value.status : "DFT";
    application.referenceNumber = this.applicantFg.value.referenceNumber;
    application.category = this.applicantFg.value.category;
    application.bctContact = this.applicantFg.value.bctContact;
    application.geographicRegion = this.applicantFg.value.geographicRegion;
    application.submittedDate = this.applicantFg.value.submittedDate;
    application.quoteIssueDueDate = this.applicantFg.value.quoteIssueDueDate;
    application.issuedDate = this.applicantFg.value.issuedDate;
    application.adjustedIssueDueDate = this.applicantFg.value.adjustedIssueDueDate;
    application.adjustedDueDateReason = this.applicantFg.value.adjustedDueDateReason;
    application.expiryDate = this.applicantFg.value.expiryDate;
    application.adjustedExpiryDate = this.applicantFg.value.adjustedExpiryDate;
    application.adjustedExpiryDateReason = this.applicantFg.value.adjustedExpiryDateReason;
    application.cancelReason = this.applicantFg.value.cancelReason;
    application.quoteCancelReason = this.applicantFg.value.quoteCancelReason;
    application.queryReason = this.applicantFg.value.queryReason;
    application.queryReasonFlag = this.applicantFg.value.queryReasonFlag;
    application.cm9reference = this.applicantFg.value.cm9reference;
    application.cm9ContainerID = this.applicantFg.value.cm9ContainerID;
    application.developmentName = this.developmentFg.value.developmentName;
    application.developmentTypeId = this.developmentFg.value.developmentTypeId;
    application.lgaid = this.developmentFg.value.lga;
    application.obligationType = this.developmentFg.value.obligationType;
    application.nswobligationReference = this.developmentFg.value.obligationReference;
    application.commonwealthObligationReference = this.developmentFg.value.cwObligationReference;

    //authorisation
    application.authoriserName = this.authFg.value.name;
    application.authoriserOrganisation = this.authFg.value.organisation;
    application.authorisationOption = this.authFg.value.authOption;

    return application;
  }

  editApplication(Id: number) {
    this.applicantFg.patchValue({
      id: Id
    });
    this.quoteService.get(Id).subscribe(result => {
      if (result != null) {
        const applicant = result.applicant;
        this.applicantFg.patchValue({
          id: result.id,
          applicantId: applicant.id,
          name: applicant.firstName,
          applicantType: applicant.subType,
          abn: applicant.abn,
          status: result.status,
          referenceNumber: result.referenceNumber,
          category: result.category,
          bctContact: result.bctContact,
          geographicRegion: result.geographicRegion,
          submittedDate: result.submittedDate,
          quoteIssueDueDate: result.quoteIssueDueDate,
          issuedDate: result.issuedDate,
          adjustedIssueDueDate: result.adjustedIssueDueDate,
          adjustedDueDateReason: result.adjustedDueDateReason,
          expiryDate: result.expiryDate,
          adjustedExpiryDate: result.adjustedExpiryDate,
          adjustedExpiryDateReason: result.adjustedExpiryDateReason,
          cancelReason: result.cancelReason,
          quoteCancelReason: result.quoteCancelReason,
          queryReason: result.queryReason,
          queryReasonFlag: result.queryReasonFlag,
          cm9reference: result.cm9reference,
          cm9ContainerID: result.cm9ContainerID

        });

        if (applicant.addresses != null && applicant.addresses.length > 0) {
          this.mailingAddress.setAddress(applicant.addresses[0]);
        }
        if (applicant.contacts != null && applicant.contacts.length > 0) {
          let contact = applicant.contacts.filter(c => c.type == "P")[0];
          if (contact != null) this.primaryContact.setContact(contact);
          contact = applicant.contacts.filter(c => c.type == "S")[0];
          if (contact != null) this.secondaryContact.setContact(contact);

        }
        this.developmentFg.patchValue({
          developmentName: result.developmentName,
          developmentTypeId: result.developmentTypeId,
          lga: result.lgaid,
          obligationType: result.obligationType,
          obligationReference: result.nswobligationReference,
          cwObligationReference: result.commonwealthObligationReference
        });

        let credit: Credit;
        result.quoteCredits.map((item, index) => {
          credit = item.credit as Credit;
          credit.id = item.id;
          credit.numberOfCredits = item.credit.totalCredits;
          credit.commonwealthOffset = item.commonwealthOffset;
          credit.threatStatus = item.threatStatus;
          this.obligations.push(credit);
        });
        this.gridApi.setRowData(this.obligations);

        //Authorisatioin details
        this.authFg.patchValue({
          name: result.authoriserName,
          organisation: result.authoriserOrganisation,
          authOption: result.authorisationOption
        });

      }
    });

    //get documents
    this.quoteService.getDocuments(Id).subscribe(result => {
      this.documents = result;
    });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  openModal() {
    this.creditsModal.open();
  }

  EditObligation($event: any) {
    if ($event.column.colId == "0") this.openDeleteAlertModal($event.data.id);
    else {
      const credit = $event.data;
      this.creditsModal.edit(credit.id, credit);
    }

  }

  //Obligation added event
  obligationAdded(credit: any) {
    credit.totalCredits = credit.numberOfCredits;
    var quoteId = Number(this.applicantFg.value.id);
    const applicationCredit: QUOTE_CREDIT = {
      quoteId: quoteId,
      credit: credit,
      threatStatus: credit.threatStatus,
      commonwealthOffset: credit.commonwealthOffset

    };

    this.quoteService.addCredit(applicationCredit).subscribe(result => {
      credit.id = Number(result);
      this.obligations.push(credit);
      this.gridApi.setRowData(this.obligations);
    });
  }

  //Obligation updated event
  obligationUpdated($event: any) {
    let credit = $event;
    const numberOfCredits = credit.numberOfCredits;
    const creditId = credit.id;
    credit.totalCredits = numberOfCredits;
    const applicationCredit: QUOTE_CREDIT = {
      id: creditId,
      quoteId: this.applicantFg.value.id,
      credit: credit,
      threatStatus: credit.threatStatus,
      commonwealthOffset: credit.commonwealthOffset

    };
    this.quoteService.updateCredit(creditId, applicationCredit).subscribe(result => {
      //refresh number of credits in the grid
      this.helperService.toasterService.success("Obligation details updated successfully.");
      var credit = this.obligations.find(c => c.id == creditId);
      if (credit != null) {
        credit.numberOfCredits = numberOfCredits;
        this.gridApi.refreshCells();
      }

    });

  }

  consentChanged($event, index: number) {
    if (index == 1) this.consent1 = $event.target.checked
    else this.consent2 = $event.target.checked

  }

  fileSelected($event: any, index: number) {
    const file: File = $event.target.files[0];
    switch (index) {
      case 1:
        this.fileNSW1 = file;
        //this.filesFg.patchValue({ nsw1: file });
        break;
      case 2:
        this.fileNSW2 = file;
        // this.filesFg.patchValue({ nsw2: file });
        break;
      case 3:
        this.fileCW = file;
        //  this.filesFg.patchValue({ cw: file });
        break;
      case 4:
        this.fileCR = file;
        //this.filesFg.patchValue({ cr: file });
        break;
      case 5:
        this.fileES = file;
        // this.filesFg.patchValue({ es: file});
        break;
    }

  }

  enableUploadButton(index: number): boolean {
    let file: any = null;
    var isValidLength: boolean = false;
    switch (index) {
      case 1:
        //file = this.filesFg.value.nsw1;
        file = this.fileNSW1;
        isValidLength = this.filesFg.controls['nsw1'].valid;
        break;
      case 2:
        file = this.fileNSW2;
        isValidLength = this.filesFg.controls['nsw2'].valid;
        break;
      case 3:
        file = this.fileCW;
        isValidLength = this.filesFg.controls['cw'].valid;
        break;
      case 4:
        file = this.fileCR;
        isValidLength = this.filesFg.controls['cr'].valid;
        break;
      case 5:
        file = this.fileES;
        isValidLength = this.filesFg.controls['es'].valid;
        break;
    }
    return isValidLength && file != null;
  }

  uploadFile(index: number) {
    let file: File;
    const applicationId = this.applicantFg.value.id;
    let fileTypeId = 0;
    let fileTypeName = "";
    const formData = new FormData();
    let fileType: any = null;
    switch (index) {
      case 1:
        //file = this.filesFg.value.nsw1;
        file = this.fileNSW1;
        fileType = this.fileTypes.find(f => f.code == "QFNSWDEV");
        break;
      case 2:
        file = this.fileNSW2;
        fileType = this.fileTypes.find(f => f.code == "QFNSWAPR");
        break
      case 3:
        file = this.fileCW;
        fileType = this.fileTypes.find(f => f.code == "QFCWAPR");
        break;
      case 4:
        file = this.fileCR;
        fileType = this.fileTypes.find(f => f.code == "QFCR");
        break
      case 5:
        file = this.fileES;
        fileType = this.fileTypes.find(f => f.code == "QFEQS");
        break;
    }

    if (fileType != null) {
      fileTypeId = fileType.id;
      fileTypeName = fileType.name;
    }

    if (fileType == null || fileTypeId <= 0) {
      this.helperService.toasterService.error("Invalid file type - unable to upload the file.");
      return;
    }
    else if (file == null) {
      this.helperService.toasterService.error("File contents are empty.");
      return;
    }
    else {
      formData.append("thumbnail", file);
      formData.append("fileTypeId", fileTypeId.toString());
      formData.append("fileTypeName", fileTypeName);
      this.fileService.uploadFile(applicationId, formData).subscribe(result => {

      });

    }

  }

  downloadFile(index: number) {
    let document: any = null
    switch (index) {
      case 1:
        document = this.documents.find(d => d.fileTypeCode == QuoteFileTypes.NSWDevelopmentApplication);
        break;
      case 2:
        document = this.documents.find(d => d.fileTypeCode == QuoteFileTypes.NSWDevelopmentApproved);
        break;
      case 3:
        document = this.documents.find(d => d.fileTypeCode == QuoteFileTypes.CommonwealthApproved);
        break;
      case 4:
        document = this.documents.find(d => d.fileTypeCode == QuoteFileTypes.CreditReport);
        break;
      case 5:
        document = this.documents.find(d => d.fileTypeCode == QuoteFileTypes.EquivalenceStatement);
        break;
    }
    if (document != null) {
      this.fileService.downloadFile(document.id, document.name);
    }
  }

  deleteDraft() {
    const modalOptions: NgbModalOptions = {
      size: 'lg'
    };
    const modalRef: NgbModalRef = this.utilityService.openModal('CONFIRMATION_MODAL', 'DELETE_DRAFT', modalOptions);
    modalRef.result.then((respnse) => {
      if (respnse) {
        const applicationId = this.applicantFg.value.id;
        this.quoteService.delete(applicationId).subscribe(result => {
          this.helperService.toasterService.success("Draft application has been deleted successfully.");
          this.router.navigate(['/quotes']);
        });
      }
    });
  }

  deleteObligation(id: any) {

    if (!this.allowDelete) {
      this.helperService.toasterService.error("Cannot delete obligations from submitted applications or issued quotes");
      return;
    }

    this.quoteService.deleteQuoteCredit(id).subscribe(result => {
      this.helperService.toasterService.success("Obligation has been deleted successfully.");
      const index = this.obligations.findIndex(obligation => obligation.id === id);
      if (index !== -1) {
        this.obligations.splice(index, 1);
        this.gridApi.setRowData(this.obligations);
      }
    });
  }

  openDeleteAlertModal(id: any) {
    const modalOptions: NgbModalOptions = {
      size: 'lg'
    };
    const modalRef: NgbModalRef = this.utilityService.openModal('CONFIRMATION_MODAL', 'CONFIRM_DELETE_QUOTECREDIT', modalOptions);
    modalRef.result.then((result) => {
      //confirmed to delete
      if (result) {
        this.deleteObligation(id);
      }
    });
  }
}
